import $ from 'jquery';

class cdpInsightProfilesHackers{
  constructor() {
    if ($('#cdp-insight-hackers').length > 0){
      this.loading()
      this.init()
    }
  }

  init(){
    var cdpStat = this;
    $(document).ready(function() {
      setTimeout(function() {
        var result = { query: JSON.stringify(SegmentQueryBuilder.getMongoQuery()) };
        $.ajax({
          url: $('#cdp-insight-hackers').data('url'),
          method: 'GET',
          data: result,
          success: function (response) {
            cdpStat.renderStats(response)
          }
        });
      }, 1000);
    })
  }

  renderStats(response){
    $('#cdp-insight-hackers .card-body .card-body h4').text(this.transform(response.profiles_count));
    $('#cdp-insight-hackers .card-body .card-text').html(`<b>${this.transform(response.profiles_count)}</b> участников использовали мошеннические методы`);
    $('#cdp-insight-hackers .peity-donut').text(`${response.profiles_percentage}/100`);
    $('#cdp-insight-hackers .peity-donut').peity('donut');
    this.loaded();
    this.toggleActionBtn(response.profiles_count);
  }

  toggleActionBtn(profiles_count){
    if (profiles_count > 0){
      $('#cdp-insight-hackers .open-new-insight-segment-modal').removeClass('d-none');
    } else {
      $('#cdp-insight-hackers .open-new-insight-segment-modal').addClass('d-none');
    }
  }

  loading(){
    $('#cdp-insight-hackers').addClass('loading');
  }

  loaded(){
    $('#cdp-insight-hackers').removeClass('loading');
  }

  transform(number) {
    return parseFloat(number).toLocaleString("ru")
  }
}

export default cdpInsightProfilesHackers;